interface IProps {
  email: string;
  emptyEmail: string;
  incorrectEmail: string;
}

interface IReturn {
  message: string;
  status: 'Error' | '';
}

const emailValidation = ({
  email,
  emptyEmail,
  incorrectEmail,
}: IProps): IReturn => {
  if (email === '') {
    return {
      status: 'Error',
      message: emptyEmail,
    };
  }
  const test = email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
  if (test) {
    return {
      status: '',
      message: '',
    };
  } else {
    return {
      status: 'Error',
      message: incorrectEmail,
    };
  }
};

export { emailValidation };
